import { useFlutterConnection } from '@/composables/useFlutterConnection';
import { useMaintenance } from '@/composables/useMaintenance';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { MaintenanceRepository } from '@/repositories/maintenanceRepository';

/**
 * メンテナンスチェック用クラス
 */
export class MaintenanceCheck {
  /**
   * @doc    コンストラクタ
   * @param  string toPath (遷移元のページURL、vue-router.beforeEachのto.path)
   */
  constructor(public toPath: string) {}

  /**
   * @doc    メンテナンスAPIを実行してレスポンスを出力・ページを表示する
   * @see    https://bobbyhadz.com/blog/typescript-property-does-not-exist-on-type#:~:text=The%20%22Property%20does%20not%20exist,type%20with%20variable%20key%20names. (type/interfaceのオブジェクトが文字列キーでインデックスづけされているときのタイプエラー)
   * @see    https://qiita.com/kerupani129/items/64ce1e80eb8efb4c2b21 (javascriptで配列から末尾の要素を取り出す)
   * @return Promise<boolean>
   */
  public doCheck = async (): Promise<boolean> => {
    const { openNewWebView } = useFlutterConnection();
    const { getFromWP } = RepositoryFactory.get('maintenance') as MaintenanceRepository;
    const { setWpMaintenance } = useMaintenance();
    const response = await getFromWP();

    // メンテナンスレスポンスを内部で保持する(レスポンスがない場合は空の配列を保持)
    setWpMaintenance(response.maintenance || []);
    // メンテナンスレスポンスに詳細ページのURLが存在し、
    // 指定されたタグ配列が存在するページからの遷移時に限り、そのページに対してメンテナンスページを開く(フラグとしてfalseを返す)
    // falseなのはVue-routerのnext(false)で遷移しないようにするため
    // 全てのページに対してメンテナンスページの表示を行う
    if (response.maintenance.detailUrl) {
      openNewWebView(response.maintenance.detailUrl);
      return false;
    }

    return true;
  };
}
